import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Loader from 'components/Loader';
import useAuth from './useAuth';

const RequireAuth = () => {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="h-screen w-full">
        <Loader />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
